const BANK_CODE_TO_NAME = {
  '005': '台灣土地銀行',
  '806': '元大銀行（大眾）',
  '118': '板信商業銀行',
  '004': '台灣銀行',
  '822': '中國信託',
  '808': '玉山銀行',
  '007': '第一銀行',
  '012': '台北富邦',
  '812': '台新銀行',
  '013': '國泰世華銀行',
};

export {
  BANK_CODE_TO_NAME,
};
